(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/search-filters/assets/javascripts/search-filter.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/search-filters/assets/javascripts/search-filter.js'); 'use strict';

const {
  useSelector
} = ReactRedux;
const {
  useRef,
  useEffect
} = React;
const {
  ReactIcon,
  Button
} = svs.ui;
const {
  feature
} = svs.core.detect;
const {
  DebounceInputV2
} = svs.lb_ui.debounceInput;
const {
  InputRangeGroupV2
} = svs.components.lbUi.inputRangeGroup;
const {
  InputSuffix
} = svs.components.lbUi.inputSuffix;
const {
  clx
} = svs.components.lbUtils.clx;
const {
  FilterProductButton
} = svs.components.marketplaceShared.searchFilters;
const {
  format
} = svs.utils;
const {
  ReactSwiper
} = svs.components;
const {
  detect
} = svs.core;
const {
  getEnhancedProducts
} = svs.components.marketplace.helpers;
const {
  desktop
} = svs.core.detect.formfactor;
const {
  GameTypeTag
} = svs.components.marketplace.gameTypeTag;
const {
  resolveProductId
} = svs.utils.products;
const {
  selectSearchFilters,
  selectGameResults
} = svs.components.marketplaceData.selectors.filters;
const FIXED_CLASS_NAME = 'is-fixed';
const BREAKPOINT_MD = 1024;
const getTriggerFixedHeight = () => {
  if (window.innerWidth >= BREAKPOINT_MD) {
    return 0;
  }
  const balanceBarAccountItemElement = document.querySelector('.balance-bar-account-item');
  const headerbottomElement = document.querySelector('.header-bottom');
  return (balanceBarAccountItemElement ? balanceBarAccountItemElement.clientHeight : 0) + (headerbottomElement ? headerbottomElement.clientHeight : 0);
};
const Filter = _ref => {
  let {
    className,
    useFixedClass = true,
    displayArrow = false,
    clearFilter,
    closeBtnFunc,
    onClose,
    setFilterName,
    toggleProduct,
    updateFractionCount,
    updateFractionPrice,
    updateSystemPrice
  } = _ref;
  const {
    fractionCountMax,
    fractionCountMin,
    fractionPriceMax,
    fractionPriceMin,
    hasActiveFilterParameters: hasActiveFilters,
    searchName: nameSearchQuery,
    products,
    subProducts,
    systemPriceMax,
    systemPriceMin
  } = useSelector(selectSearchFilters);
  const {
    totalCount: numRetailersInFilter
  } = useSelector(selectGameResults);
  const filterContainerElem = useRef();
  const filterHeaderElem = useRef();
  const filterContentElem = useRef();
  useEffect(() => {
    const handleV1 = scrollOffset => {
      if (scrollOffset >= getTriggerFixedHeight() && useFixedClass) {
        filterContainerElem.current.classList.add(FIXED_CLASS_NAME);
        filterContainerElem.current.style.height = null;
      } else {
        if (window.innerWidth < BREAKPOINT_MD) {
          const height = window.innerHeight - 55 - 44 - 44 + window.pageYOffset;
          filterContainerElem.current.style.height = "".concat(height, "px");
        }
        filterContainerElem.current.classList.remove(FIXED_CLASS_NAME);
      }
    };
    const handleV2 = scrollOffset => {
      const resultsContainer = document.querySelector('.browse-games-results-container');
      const balanceBarHeight = document.querySelector('.balance-bar').clientHeight;
      let fixedTriggerHeight;
      if (window.innerWidth < BREAKPOINT_MD) {
        fixedTriggerHeight = (resultsContainer === null || resultsContainer === void 0 ? void 0 : resultsContainer.getBoundingClientRect().y) - document.body.getBoundingClientRect().y - balanceBarHeight;
      } else {
        fixedTriggerHeight = resultsContainer === null || resultsContainer === void 0 ? void 0 : resultsContainer.getBoundingClientRect().y; 
      }

      if (resultsContainer && scrollOffset >= fixedTriggerHeight && useFixedClass) {
        filterContainerElem.current.classList.add(FIXED_CLASS_NAME);
        filterContainerElem.current.style.height = null;
      } else {
        var _document$querySelect;
        const filterOffsetTop = (_document$querySelect = document.querySelector('.marketplace-browse-games-search-filter')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getBoundingClientRect().y;
        const height = window.innerHeight - filterOffsetTop;
        filterContainerElem.current.style.height = "".concat(height, "px");
        filterContainerElem.current.classList.remove(FIXED_CLASS_NAME);
      }
    };
    const handleScroll = () => {
      if (filterContainerElem.current) {
        const scrollOffset = window.pageYOffset;
        if (feature('ft-marketplace-seperation')) {
          handleV2(scrollOffset);
        } else {
          handleV1(scrollOffset);
        }
      }
    };
    if (desktop()) {
      window.addEventListener('scroll', handleScroll);
      handleScroll();
    }
    return () => {
      if (desktop()) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  const handleSearchName = event => {
    setFilterName(event.target.value);
  };
  const handleToggleProduct = (product, subProductId) => {
    toggleProduct(product, subProductId);
  };
  const isAnyProductActive = Object.keys(products).filter(prop => products[prop]).length > 0;
  const sortedProducts = getEnhancedProducts();
  return React.createElement("div", {
    className: clx('qa-browse-games', 'search-filter', className),
    "data-testid": "qa-search-filter",
    ref: filterContainerElem
  }, displayArrow && React.createElement("div", {
    className: "arrow-up"
  }), React.createElement("div", {
    className: "search-filter-header",
    ref: filterHeaderElem
  }, React.createElement("h2", {
    className: "align-center"
  }, "Filter"), React.createElement(Button, {
    className: "qa-use-filter margin-right",
    inverted: true,
    onClick: onClose,
    size: 100,
    transparent: true
  }, "Anv\xE4nd")), React.createElement("div", {
    className: "search-filter-content",
    ref: filterContentElem
  }, React.createElement(ReactSwiper, null, desktop() && setFilterName ? React.createElement(Section, {
    className: "section-filter-query"
  }, React.createElement(DebounceInputV2, {
    className: "search-filter-input qa-search-query-name",
    inverted: true,
    onChange: handleSearchName,
    placeholder: "Ombud, spelnamn, spell\xE4ggare, ort",
    suffix: !nameSearchQuery || nameSearchQuery.length === 0 ? React.createElement(ReactIcon, {
      color: "icon-inverted",
      icon: "search",
      size: "100"
    }) : React.createElement(InputSuffix, {
      color: "icon-inverted",
      isHidden: !nameSearchQuery || nameSearchQuery.length === 0,
      onClear: () => setFilterName()
    }),
    value: nameSearchQuery
  })) : null, React.createElement("div", {
    className: "num-filter-retailers align-right padding-top-1 padding-right-1 f-100"
  }, "Spel hos", ' ', React.createElement("span", {
    className: "f-bold"
  }, numRetailersInFilter), ' ', "butiker"), React.createElement(Section, null, React.createElement("div", {
    className: "games-filter-products"
  }, sortedProducts.map(_ref2 => {
    let {
      product,
      subProductId
    } = _ref2;
    return React.createElement(FilterProductButton, {
      isActive: !isAnyProductActive || products[product] && (!subProductId || subProducts[product].includes(subProductId)),
      key: product,
      onClick: () => handleToggleProduct(product, subProductId),
      productId: resolveProductId(product)
    }, React.createElement(GameTypeTag, {
      className: "margin-top",
      productId: resolveProductId(product),
      subProductId: subProductId
    }));
  }))), React.createElement(Section, null, React.createElement(SectionHeader, null, "Andelspris"), React.createElement(InputRangeGroupV2, {
    className: "games-filter-input-group inverted"
    ,
    inputValueMax: format.Currency(fractionPriceMax)
    ,
    inputValueMin: format.Currency(fractionPriceMin),
    isInfiniteMax: true,
    maxCap: 1000,
    minCap: 10,
    onChange: _ref3 => {
      let {
        selectedMin,
        selectedMax
      } = _ref3;
      return updateFractionPrice(selectedMin, selectedMax);
    },
    selectedMax: fractionPriceMax || 1000,
    selectedMin: fractionPriceMin || 10,
    suffix: "kr"
  })), React.createElement(Section, null, React.createElement(SectionHeader, null, "Antal andelar"), React.createElement(InputRangeGroupV2, {
    className: "games-filter-input-group inverted",
    inputValueMax: fractionCountMax,
    inputValueMin: fractionCountMin,
    maxCap: 50,
    minCap: 2,
    onChange: _ref4 => {
      let {
        selectedMin,
        selectedMax
      } = _ref4;
      return updateFractionCount(selectedMin, selectedMax);
    },
    selectedMax: fractionCountMax || 50,
    selectedMin: fractionCountMin || 2,
    suffix: "st"
  })), React.createElement(Section, null, React.createElement(SectionHeader, null, "M\xF6jlig systemstorlek"), React.createElement(InputRangeGroupV2, {
    className: "games-filter-input-group inverted"
    ,
    inputValueMax: format.Currency(systemPriceMax)
    ,
    inputValueMin: format.Currency(systemPriceMin),
    maxCap: 42000,
    minCap: 20,
    onChange: _ref5 => {
      let {
        selectedMin,
        selectedMax
      } = _ref5;
      return updateSystemPrice(selectedMin, selectedMax);
    },
    selectedMax: systemPriceMax || 42000,
    selectedMin: systemPriceMin || 20,
    suffix: "kr"
  })), React.createElement(Section, {
    className: detect.formfactor.mobile() ? 'mobile-bottom-padding bottom-buttons' : 'bottom-buttons'
  }, React.createElement(Button, {
    className: "qa-clear-filter clear-filter-button",
    disabled: !hasActiveFilters,
    inverted: true,
    onClick: () => clearFilter(),
    size: 100,
    transparent: true
  }, "Rensa filter"), closeBtnFunc && React.createElement(Button, {
    className: "qa-close-filter-btn close-filter-button",
    inverted: true,
    onClick: () => closeBtnFunc(),
    size: 100,
    transparent: true
  }, "St\xE4ng")))));
};
const Section = _ref6 => {
  let {
    children,
    className = ''
  } = _ref6;
  return React.createElement("div", {
    className: "filter-section ".concat(className)
  }, children);
};
const SectionHeader = _ref7 => {
  let {
    children
  } = _ref7;
  return React.createElement("div", {
    className: "filter-section-header"
  }, children);
};
setGlobal('svs.components.marketplaceShared.searchFilters.Filter', Filter);
 })(window);